import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import * as styles from './style/index.scss'
import toWeappBj from '@assets/img/toWeappBj.png'
import { Toast } from 'antd-mobile'
import { getUrlSearch } from '@src/utils';
export default class JumpToWeApp extends ComponentExt<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            urlScheme: '',
            pictureUrl: '',
            isRequest: false
        }
        this.getQueryMsgPicture()
    }

    async componentDidMount() {
        const isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i);
        console.log("当前页面url：", window.location.href)
        if (!isMobile) {
            return this.$toast.info('请在手机打开网页链接')
        }
        const iccid = location.hash.split('?iccid=')[1];
        this.generatorSchema(iccid)
    };
    getQueryMsgPicture = async () => {
        try {
            Toast.loading('加载中');
            const res = await this.api.getQueryMsgPicture({})
            this.setState({ pictureUrl: res, isRequest: true })
            Toast.hide()
        } catch (error) {
        }
    }
    generatorSchema = async (iccid) => {
        try {
            const res = await this.api.generatorSchema({ iccid, type: getUrlSearch().type });
            if (typeof res === 'object') {
                this.$toast.info('系统异常，无法跳转')
                return
            }
            await this.setState({
                urlScheme: res
            });
            location.href = res
        } catch (e) {
        }
    };
    toWeapp = () => {
        const isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i);
        if (!isMobile) {
            return this.$toast.info('请在手机打开网页链接')
        }
        const { urlScheme } = this.state;
        if (urlScheme) {
            location.href = urlScheme
        }
    }
    render() {
        if (!this.state.isRequest) {
            return <></>
        }
        return (
            <div className={styles.wrap} style={{ backgroundImage: `url(${this.state.pictureUrl || toWeappBj})` }} onClick={this.toWeapp}>
            </div>
        )
    }
}
